import { Job } from '~hooks/useJob/models';
import useMessagingUnreadCountSelectorQuery from '~queries/useMessagingUnreadCountSelectorQuery';

export default function useMessagingJobUnreadCountQuery(
  job: Pick<Job, 'id' | 'messagingEnabled'>,
) {
  return useMessagingUnreadCountSelectorQuery(
    (unreadCounts) => unreadCounts.forJob(job.id),
    { isEnabled: job.messagingEnabled },
  );
}
